// extracted by mini-css-extract-plugin
export default {"homePageInscription":"HomePageInscription_homePageInscription__bf7OI"};